// extracted by mini-css-extract-plugin
export default {"secondaryMenu":"page-menu_secondaryMenu__3FTIi","loader":"page-menu_loader__7uI6x","appMenu":"page-menu_appMenu__tgaK0","mobileMenu":"page-menu_mobileMenu__TvToz"};